import createRoutes from '@/router/createRoutes'
import storage from "store";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  state: () => {
    return {
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || null,
      userRoutes: null
    }
  },
  mutations: {
    // 退出时清理
    emptyUser(state, data) {
      state.userInfo = null
      state.userRoutes = null

      sessionStorage.removeItem('userInfo')
    },
    // 设置用户信息
    setUserInfo(state, data) {
      state.userInfo = data
      storage.set(ACCESS_TOKEN, data.sessionId, new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
      sessionStorage.setItem('userInfo', JSON.stringify(data))
    },
    // 设置用户路由表配置
    setUserRoutes(state, data) {
      if (!data) data = createRoutes()
      state.userRoutes = data
    }
  },
  actions: {}
}
